var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
        'current-lang-avatar': _vm.avatar,
        'big-avatar': _vm.avatar && _vm.avatarSize === 'big',
        'small-avatar': _vm.avatar && _vm.avatarSize === 'small',
    },style:(!_vm.blacklist[_vm.country] ? null : `background-color: ${_vm.blacklist[_vm.country].color}`)},[(!_vm.blacklist[_vm.country])?_c('country-flag',{attrs:{"country":_vm.country,"size":_vm.size}}):_c('div',{staticClass:"w-100 h-100 d-flex align-items-center justify-content-center"},[_c('h6',{staticClass:"country-text subtitle font-weight-600 mb-0 white"},[_vm._v("\n            "+_vm._s(_vm.blacklist[_vm.country].label)+"\n        ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }